// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    AuthClientInfoResponse,
    AuthInvitationDetailsResponse,
    AuthProviderInfoResponse,
    AuthSingleSignOnInfoRequest,
    AuthSingleSignOnInfoResponse,
    ExternalLoginPatientDetailsRequest,
    ExternalLoginPatientDetailsResponse,
    ExternalLoginProviderDetailsResponse,
    ForgotPasswordRequest,
    LoginAcceptInvitationRequest,
    OAuthLoginTokenResponse,
    OAuthStandardTokenResponse,
    ObjectNoResponse,
    PatientRegistrationRequest,
    ProviderRegistrationRequest,
    RegistrationResponse,
    RegistrationVerifyRequest,
    RequestAccountAccessRequest,
    ResetPasswordProviderRequest,
    ResetPasswordRequest,
    AuthSingleSignOnInfoRequestToJSON,
    ExternalLoginPatientDetailsRequestToJSON,
    ForgotPasswordRequestToJSON,
    LoginAcceptInvitationRequestToJSON,
    PatientRegistrationRequestToJSON,
    ProviderRegistrationRequestToJSON,
    RegistrationVerifyRequestToJSON,
    RequestAccountAccessRequestToJSON,
    ResetPasswordProviderRequestToJSON,
    ResetPasswordRequestToJSON,
    AuthClientInfoResponseFromJSON,
    AuthInvitationDetailsResponseFromJSON,
    AuthProviderInfoResponseFromJSON,
    AuthSingleSignOnInfoResponseFromJSON,
    ExternalLoginPatientDetailsResponseFromJSON,
    ExternalLoginProviderDetailsResponseFromJSON,
    OAuthLoginTokenResponseFromJSON,
    OAuthStandardTokenResponseFromJSON,
    ObjectNoResponseFromJSON,
    RegistrationResponseFromJSON,
} from '../models';

export interface AuthExternalLoginPatientDetailsRequest {
    externalLoginPatientDetailsRequest: ExternalLoginPatientDetailsRequest;
}

export interface AuthLoginAcceptInvitationRequest {
    loginAcceptInvitationRequest: LoginAcceptInvitationRequest;
}

export interface AuthRegisterPatientRequest {
    patientRegistrationRequest: PatientRegistrationRequest;
}

export interface AuthRegisterPatientVerifyRequest {
    registrationVerifyRequest: RegistrationVerifyRequest;
}

export interface AuthRegisterProviderRequest {
    providerRegistrationRequest: ProviderRegistrationRequest;
}

export interface AuthRegisterProviderVerifyRequest {
    registrationVerifyRequest: RegistrationVerifyRequest;
}

export interface AuthRequestAccountAccessRequest {
    requestAccountAccessRequest: RequestAccountAccessRequest;
}

export interface AuthRequestForgotPasswordRequest {
    forgotPasswordRequest: ForgotPasswordRequest;
}

export interface AuthResetPasswordRequest {
    resetPasswordRequest: ResetPasswordRequest;
}

export interface GetAuthClientInfoRequest {
    clientId: string;
}

export interface GetAuthExternalLoginPatientDetailsRequest {
    id: string;
}

export interface GetAuthExternalLoginProviderDetailsRequest {
    code: string;
}

export interface GetAuthInvitationDetailsRequest {
    id: string;
}

export interface GetAuthProviderInfoRequest {
    code: string;
}

export interface PostSSOInfoRequest {
    authSingleSignOnInfoRequest: AuthSingleSignOnInfoRequest;
}

export interface ProviderResetPasswordRequest {
    resetPasswordProviderRequest: ResetPasswordProviderRequest;
}

/**
 * no description
 */
export class AuthApi extends runtime.BaseAPI {

    /**
     * Create external login patient details
     * Create external login patient details
     */
    async authExternalLoginPatientDetailsRaw(requestParameters: AuthExternalLoginPatientDetailsRequest): Promise<runtime.ApiResponse<ExternalLoginPatientDetailsResponse>> {
        if (requestParameters['externalLoginPatientDetailsRequest'] === null || requestParameters['externalLoginPatientDetailsRequest'] === undefined) {
            throw new runtime.RequiredError('externalLoginPatientDetailsRequest','Required parameter requestParameters.externalLoginPatientDetailsRequest was null or undefined when calling authExternalLoginPatientDetails.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/auth/external_login_patient_details`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ExternalLoginPatientDetailsRequestToJSON(requestParameters['externalLoginPatientDetailsRequest']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ExternalLoginPatientDetailsResponseFromJSON(jsonValue));
    }

    /**
     * Create external login patient details
     * Create external login patient details
     */
    async authExternalLoginPatientDetails(requestParameters: AuthExternalLoginPatientDetailsRequest): Promise<ExternalLoginPatientDetailsResponse> {
        const response = await this.authExternalLoginPatientDetailsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Post an invitation acceptance
     * Post an invitation acceptance
     */
    async authLoginAcceptInvitationRaw(requestParameters: AuthLoginAcceptInvitationRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['loginAcceptInvitationRequest'] === null || requestParameters['loginAcceptInvitationRequest'] === undefined) {
            throw new runtime.RequiredError('loginAcceptInvitationRequest','Required parameter requestParameters.loginAcceptInvitationRequest was null or undefined when calling authLoginAcceptInvitation.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/auth/invitation_acceptance`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LoginAcceptInvitationRequestToJSON(requestParameters['loginAcceptInvitationRequest']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Post an invitation acceptance
     * Post an invitation acceptance
     */
    async authLoginAcceptInvitation(requestParameters: AuthLoginAcceptInvitationRequest): Promise<ObjectNoResponse> {
        const response = await this.authLoginAcceptInvitationRaw(requestParameters);
        return await response.value();
    }

    /**
     * Register a patient
     * Register a patient
     */
    async authRegisterPatientRaw(requestParameters: AuthRegisterPatientRequest): Promise<runtime.ApiResponse<RegistrationResponse>> {
        if (requestParameters['patientRegistrationRequest'] === null || requestParameters['patientRegistrationRequest'] === undefined) {
            throw new runtime.RequiredError('patientRegistrationRequest','Required parameter requestParameters.patientRegistrationRequest was null or undefined when calling authRegisterPatient.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/auth/patient_registration`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PatientRegistrationRequestToJSON(requestParameters['patientRegistrationRequest']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => RegistrationResponseFromJSON(jsonValue));
    }

    /**
     * Register a patient
     * Register a patient
     */
    async authRegisterPatient(requestParameters: AuthRegisterPatientRequest): Promise<RegistrationResponse> {
        const response = await this.authRegisterPatientRaw(requestParameters);
        return await response.value();
    }

    /**
     * Register a patient (Step 2)
     * Register a patient (Step 2)
     */
    async authRegisterPatientVerifyRaw(requestParameters: AuthRegisterPatientVerifyRequest): Promise<runtime.ApiResponse<OAuthLoginTokenResponse>> {
        if (requestParameters['registrationVerifyRequest'] === null || requestParameters['registrationVerifyRequest'] === undefined) {
            throw new runtime.RequiredError('registrationVerifyRequest','Required parameter requestParameters.registrationVerifyRequest was null or undefined when calling authRegisterPatientVerify.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/auth/patient_registration_verification`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RegistrationVerifyRequestToJSON(requestParameters['registrationVerifyRequest']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => OAuthLoginTokenResponseFromJSON(jsonValue));
    }

    /**
     * Register a patient (Step 2)
     * Register a patient (Step 2)
     */
    async authRegisterPatientVerify(requestParameters: AuthRegisterPatientVerifyRequest): Promise<OAuthLoginTokenResponse> {
        const response = await this.authRegisterPatientVerifyRaw(requestParameters);
        return await response.value();
    }

    /**
     * Register a provider
     * Register a provider
     */
    async authRegisterProviderRaw(requestParameters: AuthRegisterProviderRequest): Promise<runtime.ApiResponse<RegistrationResponse>> {
        if (requestParameters['providerRegistrationRequest'] === null || requestParameters['providerRegistrationRequest'] === undefined) {
            throw new runtime.RequiredError('providerRegistrationRequest','Required parameter requestParameters.providerRegistrationRequest was null or undefined when calling authRegisterProvider.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/auth/provider_registration`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProviderRegistrationRequestToJSON(requestParameters['providerRegistrationRequest']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => RegistrationResponseFromJSON(jsonValue));
    }

    /**
     * Register a provider
     * Register a provider
     */
    async authRegisterProvider(requestParameters: AuthRegisterProviderRequest): Promise<RegistrationResponse> {
        const response = await this.authRegisterProviderRaw(requestParameters);
        return await response.value();
    }

    /**
     * Register a provider (Step 2)
     * Register a provider (Step 2)
     */
    async authRegisterProviderVerifyRaw(requestParameters: AuthRegisterProviderVerifyRequest): Promise<runtime.ApiResponse<OAuthLoginTokenResponse>> {
        if (requestParameters['registrationVerifyRequest'] === null || requestParameters['registrationVerifyRequest'] === undefined) {
            throw new runtime.RequiredError('registrationVerifyRequest','Required parameter requestParameters.registrationVerifyRequest was null or undefined when calling authRegisterProviderVerify.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/auth/provider_registration_verification`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RegistrationVerifyRequestToJSON(requestParameters['registrationVerifyRequest']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => OAuthLoginTokenResponseFromJSON(jsonValue));
    }

    /**
     * Register a provider (Step 2)
     * Register a provider (Step 2)
     */
    async authRegisterProviderVerify(requestParameters: AuthRegisterProviderVerifyRequest): Promise<OAuthLoginTokenResponse> {
        const response = await this.authRegisterProviderVerifyRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get information about logged in user
     * Request access to a specific provider
     */
    async authRequestAccountAccessRaw(requestParameters: AuthRequestAccountAccessRequest): Promise<runtime.ApiResponse<OAuthStandardTokenResponse>> {
        if (requestParameters['requestAccountAccessRequest'] === null || requestParameters['requestAccountAccessRequest'] === undefined) {
            throw new runtime.RequiredError('requestAccountAccessRequest','Required parameter requestParameters.requestAccountAccessRequest was null or undefined when calling authRequestAccountAccess.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["default"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/auth/account_request`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RequestAccountAccessRequestToJSON(requestParameters['requestAccountAccessRequest']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => OAuthStandardTokenResponseFromJSON(jsonValue));
    }

    /**
     * Get information about logged in user
     * Request access to a specific provider
     */
    async authRequestAccountAccess(requestParameters: AuthRequestAccountAccessRequest): Promise<OAuthStandardTokenResponse> {
        const response = await this.authRequestAccountAccessRaw(requestParameters);
        return await response.value();
    }

    /**
     * Forgot Password Request
     * Forgot Password Request
     */
    async authRequestForgotPasswordRaw(requestParameters: AuthRequestForgotPasswordRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['forgotPasswordRequest'] === null || requestParameters['forgotPasswordRequest'] === undefined) {
            throw new runtime.RequiredError('forgotPasswordRequest','Required parameter requestParameters.forgotPasswordRequest was null or undefined when calling authRequestForgotPassword.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/auth/forgot_password`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ForgotPasswordRequestToJSON(requestParameters['forgotPasswordRequest']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Forgot Password Request
     * Forgot Password Request
     */
    async authRequestForgotPassword(requestParameters: AuthRequestForgotPasswordRequest): Promise<ObjectNoResponse> {
        const response = await this.authRequestForgotPasswordRaw(requestParameters);
        return await response.value();
    }

    /**
     * Reset Password (from forgot password email)
     * Reset Password (from forgot password email)
     */
    async authResetPasswordRaw(requestParameters: AuthResetPasswordRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['resetPasswordRequest'] === null || requestParameters['resetPasswordRequest'] === undefined) {
            throw new runtime.RequiredError('resetPasswordRequest','Required parameter requestParameters.resetPasswordRequest was null or undefined when calling authResetPassword.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/auth/reset_password`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ResetPasswordRequestToJSON(requestParameters['resetPasswordRequest']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Reset Password (from forgot password email)
     * Reset Password (from forgot password email)
     */
    async authResetPassword(requestParameters: AuthResetPasswordRequest): Promise<ObjectNoResponse> {
        const response = await this.authResetPasswordRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get client info for login
     * Get client info for login
     */
    async getAuthClientInfoRaw(requestParameters: GetAuthClientInfoRequest): Promise<runtime.ApiResponse<AuthClientInfoResponse>> {
        if (requestParameters['clientId'] === null || requestParameters['clientId'] === undefined) {
            throw new runtime.RequiredError('clientId','Required parameter requestParameters.clientId was null or undefined when calling getAuthClientInfo.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/auth/client_info/{client_id}`.replace(`{${"client_id"}}`, encodeURIComponent(String(requestParameters.clientId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => AuthClientInfoResponseFromJSON(jsonValue));
    }

    /**
     * Get client info for login
     * Get client info for login
     */
    async getAuthClientInfo(requestParameters: GetAuthClientInfoRequest): Promise<AuthClientInfoResponse> {
        const response = await this.getAuthClientInfoRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get external login patient details
     * Get external login patient details
     */
    async getAuthExternalLoginPatientDetailsRaw(requestParameters: GetAuthExternalLoginPatientDetailsRequest): Promise<runtime.ApiResponse<ExternalLoginPatientDetailsResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getAuthExternalLoginPatientDetails.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/auth/external_login_patient_details/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ExternalLoginPatientDetailsResponseFromJSON(jsonValue));
    }

    /**
     * Get external login patient details
     * Get external login patient details
     */
    async getAuthExternalLoginPatientDetails(requestParameters: GetAuthExternalLoginPatientDetailsRequest): Promise<ExternalLoginPatientDetailsResponse> {
        const response = await this.getAuthExternalLoginPatientDetailsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Request provider name given provider code
     * Request provider name given provider code
     */
    async getAuthExternalLoginProviderDetailsRaw(requestParameters: GetAuthExternalLoginProviderDetailsRequest): Promise<runtime.ApiResponse<ExternalLoginProviderDetailsResponse>> {
        if (requestParameters['code'] === null || requestParameters['code'] === undefined) {
            throw new runtime.RequiredError('code','Required parameter requestParameters.code was null or undefined when calling getAuthExternalLoginProviderDetails.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.code !== undefined) {
            queryParameters['code'] = requestParameters.code;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/auth/external_login_provider_details`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ExternalLoginProviderDetailsResponseFromJSON(jsonValue));
    }

    /**
     * Request provider name given provider code
     * Request provider name given provider code
     */
    async getAuthExternalLoginProviderDetails(requestParameters: GetAuthExternalLoginProviderDetailsRequest): Promise<ExternalLoginProviderDetailsResponse> {
        const response = await this.getAuthExternalLoginProviderDetailsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get external login patient details
     * Get invitation details
     */
    async getAuthInvitationDetailsRaw(requestParameters: GetAuthInvitationDetailsRequest): Promise<runtime.ApiResponse<AuthInvitationDetailsResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getAuthInvitationDetails.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/auth/invitation_details/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => AuthInvitationDetailsResponseFromJSON(jsonValue));
    }

    /**
     * Get external login patient details
     * Get invitation details
     */
    async getAuthInvitationDetails(requestParameters: GetAuthInvitationDetailsRequest): Promise<AuthInvitationDetailsResponse> {
        const response = await this.getAuthInvitationDetailsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get provider info for login
     * Get provider info for login
     */
    async getAuthProviderInfoRaw(requestParameters: GetAuthProviderInfoRequest): Promise<runtime.ApiResponse<AuthProviderInfoResponse>> {
        if (requestParameters['code'] === null || requestParameters['code'] === undefined) {
            throw new runtime.RequiredError('code','Required parameter requestParameters.code was null or undefined when calling getAuthProviderInfo.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/auth/provider_info/{code}`.replace(`{${"code"}}`, encodeURIComponent(String(requestParameters.code))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => AuthProviderInfoResponseFromJSON(jsonValue));
    }

    /**
     * Get provider info for login
     * Get provider info for login
     */
    async getAuthProviderInfo(requestParameters: GetAuthProviderInfoRequest): Promise<AuthProviderInfoResponse> {
        const response = await this.getAuthProviderInfoRaw(requestParameters);
        return await response.value();
    }

    /**
     * Post SSO info request
     * Post SSO info request
     */
    async postSSOInfoRaw(requestParameters: PostSSOInfoRequest): Promise<runtime.ApiResponse<AuthSingleSignOnInfoResponse>> {
        if (requestParameters['authSingleSignOnInfoRequest'] === null || requestParameters['authSingleSignOnInfoRequest'] === undefined) {
            throw new runtime.RequiredError('authSingleSignOnInfoRequest','Required parameter requestParameters.authSingleSignOnInfoRequest was null or undefined when calling postSSOInfo.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/auth/sso_info`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AuthSingleSignOnInfoRequestToJSON(requestParameters['authSingleSignOnInfoRequest']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => AuthSingleSignOnInfoResponseFromJSON(jsonValue));
    }

    /**
     * Post SSO info request
     * Post SSO info request
     */
    async postSSOInfo(requestParameters: PostSSOInfoRequest): Promise<AuthSingleSignOnInfoResponse> {
        const response = await this.postSSOInfoRaw(requestParameters);
        return await response.value();
    }

    /**
     * Reset Password (Logged inl)
     * Reset Password (Logged in)
     */
    async providerResetPasswordRaw(requestParameters: ProviderResetPasswordRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['resetPasswordProviderRequest'] === null || requestParameters['resetPasswordProviderRequest'] === undefined) {
            throw new runtime.RequiredError('resetPasswordProviderRequest','Required parameter requestParameters.resetPasswordProviderRequest was null or undefined when calling providerResetPassword.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["default"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/reset_password`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ResetPasswordProviderRequestToJSON(requestParameters['resetPasswordProviderRequest']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Reset Password (Logged inl)
     * Reset Password (Logged in)
     */
    async providerResetPassword(requestParameters: ProviderResetPasswordRequest): Promise<ObjectNoResponse> {
        const response = await this.providerResetPasswordRaw(requestParameters);
        return await response.value();
    }

}
